import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActiveAssistModel } from './active-assist.model';
import { DynamicQueryAdapterService } from 'common/dynamicquery/dynamic-query-adapter.service';
import { DynamicQueryDecoratorService } from 'common/dynamicquery/dynamic-query-decorator.service';

@Injectable()
export class ActiveAssistService {

  constructor(private _dynamicQuery: DynamicQueryAdapterService,
              private _dynamicQueryDecorator: DynamicQueryDecoratorService) {
  }

  createObservableByActiveAssistId(activeAssistId: string): Observable<any> {
    if (!activeAssistId) {
      throw new Error('Missing activeAssistId!');
    }

    const visitObservable = this._dynamicQuery.getQuery('activeAssistByActiveAssistID', { ActiveAssistID: activeAssistId });
    return this._dynamicQueryDecorator.create(visitObservable, ActiveAssistModel.wrap);
  }
}
